import { useEffect } from 'react';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { useNavigate, useLocation } from 'react-router-dom';

export default function useAndroidBackButton() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    // Retorna una Promesa directamente (sin await)
    const listenerPromise = App.addListener('backButton', ({ canGoBack }) => {
      if (canGoBack) {
        navigate(-1);
      } else {
        App.exitApp();
      }
    });

    // En la limpieza se espera a que la promesa resuelva y remueve el listener
    return () => {
      listenerPromise.then((handle) => handle.remove());
    };
  }, [navigate, location.key]);
}